module.exports = __webpack_public_path__ + "assets/img/star_sentence_un4.e5a4aa49.png";